import identity from "lodash/identity";
import { useQuery } from "@tanstack/react-query";
import type { RawParams } from "@uirouter/react";
import {
    getTrendsSwitchGraph,
    trendsSwitchGraphPath,
    getTrendsTable,
    trendsTablePath,
} from "../api-client/marketTrendsApi";

export type TrendsSwitchGraphResult = Awaited<ReturnType<typeof getTrendsSwitchGraph>>;

export const useTrendsSwitchGraphQuery = <T = TrendsSwitchGraphResult>(
    queryParams: RawParams,
    enabled: boolean,
    select: (data: TrendsSwitchGraphResult) => T = identity,
) => {
    return useQuery({
        queryKey: [trendsSwitchGraphPath, queryParams],
        queryFn: async () => getTrendsSwitchGraph(queryParams),
        select: (data) => select(data),
        enabled,
    });
};

export type TrendsTableResult = Awaited<ReturnType<typeof getTrendsTable>>;

export const useTrendsTableQuery = <T = TrendsTableResult>(
    queryParams: RawParams,
    select: (data: TrendsTableResult) => T = identity,
) => {
    return useQuery({
        queryKey: [trendsTablePath, queryParams],
        queryFn: async () => getTrendsTable(queryParams),
        select: (data) => select(data),
    });
};
